import { DocumentEvents, publish, subscribe, unsubscribe } from "@/core/services/window/customEvent"
import { useEffect, useState } from "react"

export function useOpenAggregatorModal(): [boolean, (status:boolean) => void] {

  const [isOpen, setIsOpen] = useState(false)

  const setStatus = (status: boolean) => {
    if(typeof document !== "undefined") {
      (document as any).aggregatorModalStatus = status
      setIsOpen(status)
    }
  }

  const dispatch = (status: boolean) => {
    setStatus(status)
    publish(DocumentEvents.AGGREGATOR_MODAL_STATUS, { isOpen: status })
  }
  useEffect(() => {
    const listener = (e: any) => {
      if (typeof e.detail.isOpen !== 'undefined') {
        setStatus(e.detail.isOpen)
      }
    }
    subscribe(DocumentEvents.AGGREGATOR_MODAL_STATUS, listener)
    setStatus(false)
    
    return () => {
      unsubscribe(DocumentEvents.AGGREGATOR_MODAL_STATUS, listener)
    }
  }, [])

  return [isOpen, dispatch]
}